
/* injects from baggage-loader */

'use strict';

import AccountChangePasswordComponent from './account.change-password.component';

const AccountChangePasswordPageModule = angular.module('account-change-password-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.change-password', {
        url: '/change-password',
        component: 'accountChangePassword',
        // Requires valid login to visit
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          user: function(User) {
            return User.getCurrent();
          }
        }
      });
  })
  .component('accountChangePassword', new AccountChangePasswordComponent());

export default AccountChangePasswordPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/change-password/account.change-password.module.js